var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"hamburger",attrs:{"type":"button"}},_vm.$listeners),[_c('span',{staticClass:"hamburger__box"},[_c('span',{staticClass:"hamburger__inner",class:{
        'hamburger__inner--close': _vm.isActive && !_vm.isBackArrow,
        'hamburger__inner--arrow': _vm.isActive && _vm.isBackArrow,
      }})])])}
var staticRenderFns = []

export { render, staticRenderFns }